import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit, HostListener } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { Pollsandsurvey } from 'src/app/model/pollsandsurvey.model';
import { PollsandsurveyService } from 'src/app/services/pollsandsurvey.service';
import { DateService } from 'src/app/services/date.service';
import { AssigncouponComponent } from 'src/app/modal/assign-coupon/assign-coupon.component';
import { DatePipe } from '@angular/common';
@Component({
  standalone: false,
  selector: 'app-create-new-survey',
  templateUrl: './create-new-survey.component.html',
  styleUrls: ['./create-new-survey.component.scss']
})
export class CreateNewSurveyComponent implements OnInit {

  public pollsandsurvey = new Pollsandsurvey();
  private subscriptions = new Subscription();

  prakList: any = [];
  finalSubmissionArray = [];
  selectedDate: any;
  formatDate: any;
  selectedToDate: any;
  formatToDate: any;
  afterConvertFile: any = [];
  images = [];
  couponStartDate: any;
  couponEndDate: any;
  minDate = undefined;
  uploadData: any;
  parkId: any;
  companyList: any;
  buildingList: any;
  buildingListMulti: any;
  buildingListTemp: any;
  tenantListTemp: any;
  buildingListTempNew: any;
  tenantListTempNew: any;
  buildingId: any;
  eventCategoryList: any;
  isshowEventCatList: boolean = false;
  searchText: string = '';
  mainCouponList = [];
  public sharedDataNew: any;
  couponId: any;
  couponTitle: string = '';
  hideShowAssignCoupon: boolean = false;
  buildingIds = [];
  dataForCompanyList = [];
  eventCatListOnlyId = [];
  dataForSendEventList = [];
  eventMainList: any;
  mainSurveyList = [];
  keyword = 'name';
  mainSurveyListOnlyName = [];
  prevSurveyId: any;
  surveyDetails: any;
  currentSurveyId: any;
  activeIds: string[] = ['form_row_01', 'form_row_02'];
  opened: boolean = true;
  showHideUseDraft: any;

  getActiveIds(index: number): string[] {
    return [`form_row_01_${index}`, `form_row_02_${index}`];
  }
  selectedBuldingIds = [];
  selectedTenantIds = [];
  selectedParkIds = [];
  buildingSelectFocused: boolean = false;
  tenantSelectFocused: boolean = false;
  parkSelectFocused: boolean = false;
  selectAllValue: any;
  selectedBuildingAll: boolean = false;
  selectedTenantAll: boolean = false;
  selectedParkAll: boolean = false;

  myForm!: FormGroup;
  buildingListLength: any;
  companyListLength: any;
  parkListLength: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private pollsandsurveyService: PollsandsurveyService,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    public datepipe: DatePipe,
  ) {

    if (this.isshowEventCatList === false) {
      this.myForm = this.formBuilder.group({
        newSurveyGroups: this.formBuilder.array([this.newNotes()]),
        createdBy: '',
        isActive: true,
      });
    }

    if (this.isshowEventCatList === true) {
      this.myForm = this.formBuilder.group({
        newSurveyGroups: this.formBuilder.array([this.newNotesEvents()]),
        createdBy: '',
        isActive: true,
      });
    }


    localStorage.setItem('expandNavCreateview', 'true');
    const route = this.sideNavService.routingChunks({
      name: 'Create and View',
      subNav: '0',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(route);

    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate(),
    };
  }

  ngOnInit(): void {
    this.buildingListLength = 0;
    this.companyListLength = 0;
    this.parkListLength = 0;
    this.selectAllValue = 'All';
    this.couponTitle = '';
    this.showHideUseDraft = 0;
    this.opened = true;
    localStorage.removeItem('previous_survey_id_draft');
    localStorage.removeItem('current_survey_id_draft');

    console.log(localStorage.getItem('previous_survey_id_draft'));

    this.pollsandsurvey.surveytype = '1';
    // this.pollsandsurvey.name = this.surveyDetails.data.surveyName;
    this.pollsandsurvey.parkid = '';
    this.pollsandsurvey.buildingid = '';
    this.pollsandsurvey.tenantid = '';
    this.pollsandsurvey.eventid = '';
    // this.pollsandsurvey.startdate = this.datepipe.transform(this.surveyDetails.data.surveyStartDate, 'YYYY-MM-dd');
    // this.pollsandsurvey.enddate = this.datepipe.transform(this.surveyDetails.data.surveyEndDate, 'YYYY-MM-dd');
    // this.pollsandsurvey.couponId = this.surveyDetails.data.couponId;

    this.hideShowAssignCoupon = false;
    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');

    this.isshowEventCatList = false;

    this.pollsandsurveyService.getOptionDynamic.subscribe(data => {
      this.sharedDataNew = data;
      if (typeof this.sharedDataNew.couponTitle == undefined || this.sharedDataNew.couponTitle == 'undefined') {
        setTimeout(() => {
          this.couponId = '';
          this.couponTitle = '';
          this.hideShowAssignCoupon = false;
        }, 300);
      } else {
        setTimeout(() => {
          this.couponId = this.sharedDataNew.coupon_id;
          this.couponTitle = this.sharedDataNew.coupon_title;
          this.hideShowAssignCoupon = true;
          this.pollsandsurvey.couponId = this.sharedDataNew.coupon_id;
        }, 300);
      }
    });

    this.getParkDetails();
    this.getTheSurveyist();
    this.clearLocalData();
    // this.getEventCategoryList();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavCreateview');
    this.subscriptions.unsubscribe();
  }

  searchByText(event: any) {

  }

  getParkDetails() {
    this.pollsandsurveyService.getParkByCLAId().subscribe((res) => {
      if (res.isValid) {
        this.prakList = res?.list;
        this.prakList.sort((a, b) => {
          if (a.parkName < b.parkName) { return -1; }
          if (a.parkName > b.parkName) { return 1; }
          return 0;
        });
        this.parkListLength = this.prakList.length;
      }
    });
  }

  onSubmit(): void {
    if (this.myForm.valid) {

      this.finalSubmissionArray = [];

      // for (let i = 0; i <= this.myForm.value.newSurveyGroups.length - 1; i++) {
      // }

      if (this.couponStartDate == undefined || this.couponStartDate == 'undefined') {
        this.couponStartDate = this.pollsandsurvey.startdate;
      } else {
        this.couponStartDate = this.couponStartDate;
      }
      if (this.couponEndDate == undefined || this.couponEndDate == 'undefined') {
        this.couponEndDate = this.pollsandsurvey.enddate;
      } else {
        this.couponEndDate = this.couponEndDate;
      }
      if (this.couponId == undefined || this.couponId == 'undefined') {
        this.couponId = this.couponId;
      } else {
        this.couponId = this.couponId;
      }

      this.finalSubmissionArray.push({
        'surveyType': parseInt(this.myForm.value.newSurveyGroups[0].surveytype),
        'surveyName': this.myForm.value.newSurveyGroups[0].name,
        'parkIds': this.myForm.value.newSurveyGroups[0].eventid ? [this.myForm.value.newSurveyGroups[0].parkid] : this.selectedParkIds,
        // 'buildingId': this.myForm.value.newSurveyGroups[0].buildingid ? this.myForm.value.newSurveyGroups[0].buildingid : null,
        // 'tenantId': this.myForm.value.newSurveyGroups[0].tenantid ? this.myForm.value.newSurveyGroups[0].tenantid : null,
        'buildingIds': this.selectedBuldingIds ? this.selectedBuldingIds : null,
        'tenantIds': this.selectedTenantIds ? this.selectedTenantIds : null,
        'eventId': this.myForm.value.newSurveyGroups[0].eventid ? this.myForm.value.newSurveyGroups[0].eventid : null,
        'startDate': this.couponStartDate,
        'endDate': this.couponEndDate,
        // 'couponId': this.couponId,
        'couponId': null,
        'createdBy': localStorage.getItem('claAdminId'),
      });

      console.log(this.finalSubmissionArray[0]);

      this.pollsandsurveyService
        .createNewPollsandSurvey(this.finalSubmissionArray[0])
        .subscribe((res) => {
          this.currentSurveyId = res?.data.surveyId;
          // this.router.navigate(['/list-survey/']);
          console.log(localStorage.getItem('previous_survey_id_draft'));
          if (localStorage.getItem('previous_survey_id_draft') == null || localStorage.getItem('previous_survey_id_draft') == 'null') {
            this.router.navigate(['/survey-details/' + this.currentSurveyId]);
          } else {
            this.router.navigate(['/survey-details-template/' + this.currentSurveyId]);
          }
        });
    } else {
      this.myForm.markAllAsTouched();
    }
  }

  newSurveyGroups(): FormArray {
    return this.myForm.get('newSurveyGroups') as FormArray;
  }

  // newNotes(isshowEventCatList): FormGroup {
  //   if (isshowEventCatList === false) {
  //     console.log(isshowEventCatList);
  //     return this.formBuilder.group({
  //       surveytype: ['1', Validators.required],
  //       name: ['', Validators.required],
  //       parkid: ['', Validators.required],
  //       startdate: ['', Validators.required],
  //       enddate: ['', Validators.required],
  //       buildingid: ['', Validators.required],
  //       tenantid: ['', Validators.required],
  //       eventid: [''],
  //     });
  //   } else if (isshowEventCatList === 'true') {
  //     console.log(isshowEventCatList);
  //     return this.formBuilder.group({
  //       eventid: ['', Validators.required],
  //       surveytype: ['Event', Validators.required],
  //       name: ['', Validators.required],
  //       parkid: ['', Validators.required],
  //       startdate: ['', Validators.required],
  //       enddate: ['', Validators.required],
  //       //buildingid: [''],
  //       //tenantid: [''],
  //     });
  //   }
  // }


  getDateinNgbFormat(date) {
    let dt = (date.split('T')[0]).split('-')
    let fDate = {
      year: parseInt(dt[0]),
      month: parseInt(dt[1]),
      day: parseInt(dt[2])
    }
    return fDate
  }


  newNotes(): FormGroup {
    return this.formBuilder.group({
      surveytype: ['1', Validators.required],
      name: ['', Validators.required],
      parkid: [(this.pollsandsurvey.parkid) ? this.pollsandsurvey.parkid : '', Validators.required],
      startdate: [(this.pollsandsurvey.startdate) ? this.getDateinNgbFormat(this.pollsandsurvey.startdate) : '', Validators.required],
      enddate: [(this.pollsandsurvey.enddate) ? this.getDateinNgbFormat(this.pollsandsurvey.enddate) : '', Validators.required],
      buildingid: [(this.pollsandsurvey.buildingid) ? this.pollsandsurvey.buildingid : '', Validators.required],
      tenantid: [(this.pollsandsurvey.tenantid) ? this.pollsandsurvey.tenantid : '', Validators.required],
      // eventid: [''],
    });
  }

  newNotesEvents(): FormGroup {
    return this.formBuilder.group({
      surveytype: ['2', Validators.required],
      name: ['', Validators.required],
      parkid: [(this.pollsandsurvey.parkid) ? this.pollsandsurvey.parkid : '', Validators.required],
      startdate: [(this.pollsandsurvey.startdate) ? this.getDateinNgbFormat(this.pollsandsurvey.startdate) : '', Validators.required],
      enddate: [(this.pollsandsurvey.enddate) ? this.getDateinNgbFormat(this.pollsandsurvey.enddate) : '', Validators.required],
      eventid: [(this.pollsandsurvey.eventid) ? this.pollsandsurvey.eventid : '', Validators.required],
      //buildingid: [''],
      //tenantid: [''],
    });
  }

  addMore(): void {
    this.newSurveyGroups().push(this.newNotes());
  }

  removeBlock(i: number) {
    this.newSurveyGroups().removeAt(i);
  }

  goToListPage() {
    this.router.navigate(['/list-survey/']);
  }

  public updateSelectedDate(date: NgbDate) {
    this.couponStartDate = date.year + '-' + date.month + '-' + date.day;
    // if (date.day.toString().length == 1) {
    //   var day = '0' + date.day;
    // } else {
    //   var day = date.day.toString();
    // }
    // if (date.month.toString().length == 1) {
    //   var month = '0' + date.month;
    // } else {
    //   var month = date.month.toString();
    // }
    // this.couponStartDate = date.year + '-' + month + '-' + day;
    this.couponStartDate = this.datepipe.transform(this.couponStartDate, 'YYYY-MM-dd');
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.selectedDate = this.convertFormat(date.year, date.month, date.day);
    this.formatDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
  }

  public async updateSelectedToDate(date: NgbDate) {
    this.couponEndDate = date.year + '-' + date.month + '-' + date.day;
    // if (date.day.toString().length == 1) {
    //   var day = '0' + date.day;
    // } else {
    //   var day = date.day.toString();
    // }
    // if (date.month.toString().length == 1) {
    //   var month = '0' + date.month;
    // } else {
    //   var month = date.month.toString();
    // }
    // this.couponEndDate = date.year + '-' + month + '-' + day;
    this.couponEndDate = this.datepipe.transform(this.couponEndDate, 'YYYY-MM-dd');
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.selectedToDate = this.convertFormat(date.year, date.month, date.day);

    const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    // if (date.day < this.couponStartDate.split('-')[2]) {
    //   this.appStateSrv.showToast(
    //     'End date can not be less than start date.'
    //   );
    //   await delay(2000);
    // }

    this.formatToDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
  }

  convertFormat(y, m, d) {
    return y + '-' + m + '-' + d;
  }

  getParkId(event) {
    console.log(event.target.value);
    this.parkId = event.target.value;
    if (event.target.value != '') {
      this.getBuildingList(this.parkId);
      this.getEventCategoryList(this.parkId);
    }
  }

  getBuildingId(event) {
    console.log(event.target.value);
    this.buildingId = event.target.value;
    if (event.target.value != '') {
      this.parkId = this.parkId ? this.parkId : localStorage.getItem('parkId');
      this.getTenantListAll(this.parkId, this.buildingId);
    }
  }

  getBuildingList(parkId: string) {
    this.pollsandsurveyService.getBuildingList(parkId).subscribe((res) => {
      if (res?.isValid === true) {
        this.buildingList = res?.list;
        this.buildingListLength = this.buildingList.length;
        if (this.selectedBuldingIds.length != this.buildingList.length) {
          this.selectedBuildingAll = false;
        } else {
          this.selectedBuildingAll = true;
        }
        // this.buildingList.unshift(allOpt);
        //this.selectedBuldingIds = this.pollsandsurvey.buldingIdMultiple;
        //console.log(this.selectedBuldingIds);
      }
    });
  }

  getBuildingListMultiple(parkId: any) {
    this.buildingListTemp = [];
    this.pollsandsurveyService.getBuildingListMulti(parkId).subscribe((res) => {
      if (res?.isValid === true) {
        this.buildingList = res?.list;
        console.log(this.buildingList);

        for (let i = 0; i <= this.buildingList.length - 1; i++) {
          //console.log(this.buildingList[i].parkName);
          let parkList = [{
            parkId: this.buildingList[i].parkId,
            parkName: this.buildingList[i].parkName,
            isActive: this.buildingList[i].isActive,
          }];
          for (let j = 0; j < this.buildingList[i].buildings.length; j++) {
            //console.log(this.buildingList[i].buildings[0]);
            this.buildingListTemp.push({
              parkList,
              buildingName: this.buildingList[i].buildings[j].buildingName,
              parkBuildingId: this.buildingList[i].buildings[j].buildingId,
            });
          }
        }
        this.buildingListTempNew = [{ data: null, list: this.buildingListTemp }][0]?.list;
        console.log(this.buildingListTempNew);

        this.buildingListLength = this.buildingList.length;
        if (this.selectedBuldingIds.length != this.buildingList.length) {
          this.selectedBuildingAll = false;
        } else {
          this.selectedBuildingAll = true;
        }
        // this.buildingList.unshift(allOpt);
        //this.selectedBuldingIds = this.pollsandsurvey.buldingIdMultiple;
        //console.log(this.selectedBuldingIds);
      }
    });
  }

  getTenantListAll(parkId: string, parkTenantId: string) {
    this.tenantListTemp = [];
    this.buildingIds = [];
    this.buildingIds.push(parkTenantId);
    this.dataForCompanyList = [];
    this.dataForCompanyList.push({
      "parkId": parkId,
      "buildingId": this.buildingIds,
      "isActive": true
    })
    this.pollsandsurveyService.getCompanyList(this.dataForCompanyList[0]).subscribe((res) => {
      if (res?.isValid) {
        // this.companyList = res.list;
        this.companyList = res.list.filter((item: { isActive: any }) => {
          return item.isActive == true;
        });

        for (let i = 0; i <= this.companyList.length - 1; i++) {
          //console.log(this.companyList[i].parkBuildingName);
          let parkBuildingList = [{
            parkBuildingId: this.companyList[i].parkBuildingId,
            parkBuildingName: this.companyList[i].parkBuildingName,
            isActive: this.companyList[i].isActive,
          }];
          for (let j = 0; j < this.companyList[i].parkTenantDetails.length; j++) {
            //console.log(this.companyList[i].parkTenantDetails[0]);
            this.tenantListTemp.push({
              parkBuildingList,
              parkTenantName: this.companyList[i].parkTenantDetails[j].parkTenantName,
              parkTenantId: this.companyList[i].parkTenantDetails[j].parkTenantId,
            });
          }
        }
        this.tenantListTempNew = [{ data: null, list: this.tenantListTemp }][0]?.list;
        console.log(this.tenantListTempNew);
      }
    });
  }

  getTenantListAllMultiple(parkId: string, buildingIds: string) {
    this.tenantListTemp = [];
    this.dataForCompanyList = [];
    this.dataForCompanyList.push({
      "parkId": parkId,
      "buildingId": buildingIds,
      "isActive": true
    })
    this.pollsandsurveyService.getCompanyList(this.dataForCompanyList[0]).subscribe((res) => {
      if (res?.isValid) {
        // this.companyList = res.list;
        this.companyList = res.list.filter((item: { isActive: any }) => {
          return item.isActive == true;
        });

        for (let i = 0; i <= this.companyList.length - 1; i++) {
          //console.log(this.companyList[i].parkBuildingName);
          let parkBuildingList = [{
            parkBuildingId: this.companyList[i].parkBuildingId,
            parkBuildingName: this.companyList[i].parkBuildingName,
            isActive: this.companyList[i].isActive,
          }];
          for (let j = 0; j < this.companyList[i].parkTenantDetails.length; j++) {
            //console.log(this.companyList[i].parkTenantDetails[0]);
            this.tenantListTemp.push({
              parkBuildingList,
              parkTenantName: this.companyList[i].parkTenantDetails[j].parkTenantName,
              parkTenantId: this.companyList[i].parkTenantDetails[j].parkTenantId,
            });
          }
        }
        this.tenantListTempNew = [{ data: null, list: this.tenantListTemp }][0]?.list;
        console.log(this.tenantListTempNew);

        this.companyListLength = this.companyList.length;
        if (this.selectedTenantIds.length != this.companyList.length) {
          this.selectedTenantAll = false;
        } else {
          this.selectedTenantAll = true;
        }
      }
    });
  }

  getEventCategoryList(parkId: string) {
    this.pollsandsurveyService.getEventCategory().subscribe((res) => {
      this.eventCategoryList = res;
      console.log(this.eventCategoryList);
      for (let i = 0; i < this.eventCategoryList.length - 1; i++) {
        this.eventCatListOnlyId.push(this.eventCategoryList[i].eventCategoryId);
      }
      this.getEventListAll(parkId, this.eventCatListOnlyId);
    });
  }

  getEventListAll(parkId: string, eventCatListOnlyId: any) {
    this.dataForSendEventList = [];
    this.dataForSendEventList.push({
      "parkId": parkId,
      "eventTypeId": eventCatListOnlyId
    })
    this.pollsandsurveyService.getEventList(this.dataForSendEventList[0]).subscribe((res) => {
      if (res?.isValid) {
        this.eventMainList = res.list[0].eventHistoryDetails; //eventHistoryDetails //activeEventDetails
        // console.log(this.eventMainList);
      }
    });
  }

  checkSurveyType(event) {
    if (event.target.value == '2') {
      this.isshowEventCatList = true;
    } else {
      this.isshowEventCatList = false;
    }
    if (this.isshowEventCatList === false) {
      this.myForm = this.formBuilder.group({
        newSurveyGroups: this.formBuilder.array([this.newNotes()]),
        createdBy: '',
        isActive: true,
      });
    }

    if (this.isshowEventCatList === true) {
      this.myForm = this.formBuilder.group({
        newSurveyGroups: this.formBuilder.array([this.newNotesEvents()]),
        createdBy: '',
        isActive: true,
      });
    }
  }

  openModal(): void {

    const modalOptions: NgbModalOptions = {
      size: 'lg',
    };

    const modalRef = this.modalService.open(AssigncouponComponent, modalOptions);

    modalRef.componentInstance.couponId = this.pollsandsurvey.couponId;
    modalRef.componentInstance.couponTitle = this.pollsandsurvey.couponTitle;
  }

  getTheSurveyist() {
    this.mainSurveyListOnlyName = [];
    this.pollsandsurveyService.getAllPollsAndSurveyList().subscribe((res) => {
      if (res?.isValid === true) {
        // this.mainSurveyList = res?.list;
        this.mainSurveyList = res?.list.filter((item: { isActive: any }) => {
          return item.isActive === true;
        });
        for (let i = 0; i <= this.mainSurveyList.length - 1; i++) {
          this.mainSurveyListOnlyName.push({
            "id": this.mainSurveyList[i].surveyId,
            "name": this.mainSurveyList[i].surveyName,
          });
        }
        console.log(this.mainSurveyListOnlyName);
      } else {
        this.mainSurveyList = [];
      }
    });
  }

  saveDataAsDraft() {
    this.getSurveyDetailsSingle(this.prevSurveyId);
  }

  onChangeSearch(event: any) {
    console.log(event);
  }

  onFocused(event: any) {
    // console.log(event);
  }

  selectEvent(event: any) {
    this.prevSurveyId = event.id;
    localStorage.setItem('previous_survey_id_draft', this.prevSurveyId);
    this.showHideUseDraft = 1;
    //this.getSurveyDetailsSingle(this.prevSurveyId);
  }

  clearLocalData() {
    localStorage.removeItem('previous_survey_id_draft');
    this.myForm.reset();
    this.pollsandsurvey.surveytype = '1';
    this.pollsandsurvey.parkid = '';
    this.pollsandsurvey.buildingid = '';
    this.pollsandsurvey.tenantid = '';
    this.pollsandsurvey.eventid = '';
    this.showHideUseDraft = 0;
  }

  getParkIdFromEdit(parkId: string) {
    if (parkId != '') {
      this.parkId = parkId ? parkId : localStorage.getItem('parkId');
      this.getBuildingList(this.parkId);
    }
  }

  getParkIdFromEditOnlyEvent(parkId: string) {
    if (parkId != '') {
      this.parkId = parkId ? parkId : localStorage.getItem('parkId');
      this.getEventCategoryList(this.parkId);
    }
  }

  getBuildingIdEdit(parkId: string, buildingId: string) {
    if (parkId != '') {
      this.parkId = parkId ? parkId : localStorage.getItem('parkId');
      this.getTenantListAll(this.parkId, buildingId);
    }
  }

  getBuildingIdEditMultiple(parkId: string, buildingIds: any) {
    if (parkId != '') {
      this.parkId = this.selectedParkIds; // parkId ? parkId : localStorage.getItem('parkId');
      this.getTenantListAllMultiple(this.parkId, buildingIds);
    }
  }

  getSurveyDetailsSingle(surveyId) {

    this.pollsandsurveyService.getSurveyDetails(surveyId).subscribe((res) => {
      if (res?.isValid === true) {
        this.surveyDetails = res;

        // this.prakList = [];
        this.buildingList = [];
        this.companyList = [];
        this.eventMainList = [];

        this.pollsandsurvey.surveytype = this.surveyDetails.data.surveyType.toString();
        this.pollsandsurvey.name = this.surveyDetails.data.surveyName;

        this.pollsandsurvey.parkid = this.surveyDetails.data.parkId;
        this.pollsandsurvey.buildingid = this.surveyDetails.data.buildingId;
        this.pollsandsurvey.tenantid = this.surveyDetails.data.tenantId;

        this.pollsandsurvey.buldingIdMultiple = this.surveyDetails.data.buildingIds;
        this.pollsandsurvey.tenantIdMultiple = this.surveyDetails.data.tenantIds;
        this.pollsandsurvey.parkIdMultiple = this.surveyDetails.data.parkIds;

        this.pollsandsurvey.eventid = this.surveyDetails.data.eventId;
        this.pollsandsurvey.startdate = this.datepipe.transform(this.surveyDetails.data.surveyStartDate, 'YYYY-MM-dd');
        this.pollsandsurvey.enddate = this.datepipe.transform(this.surveyDetails.data.surveyEndDate, 'YYYY-MM-dd');
        this.pollsandsurvey.couponId = this.surveyDetails.data.couponId;

        this.selectedBuldingIds = this.pollsandsurvey.buldingIdMultiple;
        this.buildingSelectFocused = true;
        this.selectedTenantIds = this.pollsandsurvey.tenantIdMultiple;
        this.tenantSelectFocused = true;
        this.selectedParkIds = this.pollsandsurvey.parkIdMultiple;
        this.parkSelectFocused = true;

        console.log(this.pollsandsurvey.couponId);
        if (this.pollsandsurvey.couponId != 'null' || this.pollsandsurvey.couponId != null) {
          // this.getCouponDetails(this.pollsandsurvey.couponId);
        }

        console.log(this.pollsandsurvey.buildingid);
        console.log(this.pollsandsurvey.tenantid);
        console.log(this.pollsandsurvey.parkid);

        if (this.surveyDetails.data.surveyType.toString() == "1") {
          this.isshowEventCatList = false;
          this.getParkIdFromEdit(this.pollsandsurvey.parkid);
          // this.getBuildingIdEdit(this.pollsandsurvey.parkid, this.pollsandsurvey.buildingid); //closed for multiple
          //for new multiselect
          let option = {
            parkId: this.selectedParkIds,
            isActive: true
          }
          this.getBuildingListMultiple(option);
          let newParkId = localStorage.getItem('parkId');
          this.getBuildingIdEditMultiple(newParkId, this.selectedBuldingIds);
          // update for multipark
          // this.getBuildingIdEditMultiple(this.pollsandsurvey.parkid, this.selectedBuldingIds);
        }

        if (this.surveyDetails.data.surveyType.toString() == "2") {
          this.isshowEventCatList = true;
          this.pollsandsurvey.parkid = this.pollsandsurvey.parkIdMultiple[0];
          let newParkId = this.pollsandsurvey.parkIdMultiple[0];
          this.getParkIdFromEditOnlyEvent(newParkId);
          //closed for new logic
          //this.getParkIdFromEditOnlyEvent(this.surveyDetails.data.parkId);
        }

        if (this.isshowEventCatList === false) {
          this.myForm = this.formBuilder.group({
            newSurveyGroups: this.formBuilder.array([this.newNotes()]),
            createdBy: '',
            isActive: true,
          });
        }

        if (this.isshowEventCatList === true) {
          this.myForm = this.formBuilder.group({
            newSurveyGroups: this.formBuilder.array([this.newNotesEvents()]),
            createdBy: '',
            isActive: true,
          });
        }
      }
    });
  }

  getCouponDetails(couponId) {
    this.pollsandsurveyService.getCuoponDetails(couponId).subscribe((res) => {
      if (res?.isValid === true) {
        console.log(res.data.couponTitle);
        this.couponTitle = res.data.couponTitle;
        this.couponId = res.data.couponId;
        this.pollsandsurvey.couponTitle = res.data.couponTitle;
      }
    });
  }

  getBuildingIdMultiple(data: any) {
    // if (data != '') {
    //   this.parkId = this.parkId ? this.parkId : localStorage.getItem('parkId');
    //   this.getTenantListMultiple(this.parkId, data);
    // }
    // previous for single park
    // this.parkId = this.parkId ? this.parkId : localStorage.getItem('parkId');
    // now for multiple park
    this.parkId = this.selectedParkIds;
    this.getTenantListMultiple(this.parkId, data);
  }

  getTenantListMultiple(parkId: string, buildingIds: any) {
    this.tenantListTemp = [];
    this.dataForCompanyList = [];
    this.dataForCompanyList.push({
      "parkId": parkId,
      "buildingId": buildingIds,
      "isActive": true
    })
    this.pollsandsurveyService.getCompanyList(this.dataForCompanyList[0]).subscribe((res) => {
      if (res?.isValid) {
        // this.companyList = res.list;
        this.companyList = res?.list.filter((item: { isActive: any }) => {
          return item.isActive == true;
        });

        for (let i = 0; i <= this.companyList.length - 1; i++) {
          //console.log(this.companyList[i].parkBuildingName);
          let parkBuildingList = [{
            parkBuildingId: this.companyList[i].parkBuildingId,
            parkBuildingName: this.companyList[i].parkBuildingName,
            isActive: this.companyList[i].isActive,
          }];
          for (let j = 0; j < this.companyList[i].parkTenantDetails.length; j++) {
            //console.log(this.companyList[i].parkTenantDetails[0]);
            this.tenantListTemp.push({
              parkBuildingList,
              parkTenantName: this.companyList[i].parkTenantDetails[j].parkTenantName,
              parkTenantId: this.companyList[i].parkTenantDetails[j].parkTenantId,
            });
          }
        }
        this.tenantListTempNew = [{ data: null, list: this.tenantListTemp }][0]?.list;
        console.log(this.tenantListTempNew);

        this.companyListLength = this.companyList.length;
      }
    });
  }

  selectBuildingData(e) {
    console.log(e);
    this.selectedBuldingIds = [];
    for (let i = 0; i <= e.length - 1; i++) {
      this.selectedBuldingIds.push(e[i].parkBuildingId);
    }
    this.selectedBuldingIds = this.selectedBuldingIds.filter((value, index, array) => array.indexOf(value) === index);
    if (this.selectedBuldingIds.length != this.buildingListTempNew.length) {
      this.selectedBuildingAll = false;
    } else {
      this.selectedBuildingAll = true;
    }
    if (this.selectedBuldingIds.length == 0) {
      this.clearSelectedDataTenant();
      this.selectedTenantIds = [];
      this.selectedBuildingAll = false;
    }
    this.getBuildingIdMultiple(this.selectedBuldingIds);
    console.log(this.selectedBuldingIds);
  }

  clearSelectedData() {
    this.selectedBuldingIds.length = 0;
  }

  selectParkData(e) {
    for (let i = 0; i <= e.length - 1; i++) {
      this.selectedParkIds.push(e[i].parkId);
    }
    this.selectedParkIds = this.selectedParkIds.filter((value, index, array) => array.indexOf(value) === index);
    console.log(this.selectedParkIds);
    let option = {
      parkId: this.selectedParkIds,
      isActive: true
    }
    if (this.selectedParkIds.length != this.prakList.length) {
      this.selectedParkAll = false;
    } else {
      this.selectedParkAll = true;
    }
    if (this.selectedParkIds.length == 0) {
      this.clearSelectedDataPark();
      this.selectedBuldingIds = [];
      this.selectedParkAll = false;
    }
    this.getBuildingListMultiple(option);
  }

  clearSelectedDataPark() {
    this.selectedParkIds.length = 0;
  }

  onBuildingSelectOpen(index) {
    this.buildingSelectFocused = true;
  }

  onParkgSelectOpen(index) {
    this.parkSelectFocused = true;
  }

  selectTenantData(e) {
    console.log(e);
    for (let i = 0; i <= e.length - 1; i++) {
      this.selectedTenantIds.push(e[i].parkTenantId);
    }
    this.selectedTenantIds = this.selectedTenantIds.filter((value, index, array) => array.indexOf(value) === index);
    if (this.selectedTenantIds.length != this.tenantListTempNew.length) {
      this.selectedTenantAll = false;
    } else {
      this.selectedTenantAll = true;
    }
    console.log(this.selectedTenantIds);
  }

  clearSelectedDataTenant() {
    this.selectedTenantIds.length = 0;
  }

  onTenantSelectOpen(index) {
    this.tenantSelectFocused = true;
  }

  selectAll(event) {
    if (event.target.checked) {
      this.selectedBuildingAll = true;
      this.selectedTenantAll = false;
      this.selectedBuldingIds = this.buildingListTempNew.map((x) => x.parkBuildingId);
      this.selectedBuldingIds = this.selectedBuldingIds.filter((value, index, array) => array.indexOf(value) === index);
      console.log(this.selectedBuldingIds);
      this.getBuildingIdMultiple(this.selectedBuldingIds);
    } else {
      this.clearSelectedDataTenant();
      this.selectedTenantIds = [];
      this.selectedBuildingAll = false;
      this.selectedBuldingIds = [];
      // this.getBuildingIdMultiple(this.selectedBuldingIds);
    }
  }

  selectAllTenanat(event) {
    if (event.target.checked) {
      // this.selectedTenantIds = this.companyList.map((j) => j.tenantId);
      this.selectedTenantIds = this.tenantListTempNew.map((j) => j.parkTenantId);
      this.selectedTenantIds = this.selectedTenantIds.filter((value, index, array) => array.indexOf(value) === index);
      console.log(this.selectedTenantIds);
      this.selectedTenantAll = true;
    } else {
      this.selectedTenantIds = [];
      this.selectedTenantAll = false;
    }
  }

  selectAllPark(event) {
    if (event.target.checked) {
      this.selectedParkAll = true;
      this.selectedBuildingAll = false;
      this.selectedTenantAll = false;
      this.selectedParkIds = this.prakList.map((x) => x.parkId);
      this.selectedParkIds = this.selectedParkIds.filter((value, index, array) => array.indexOf(value) === index);
      console.log(this.selectedParkIds);
      let option = {
        parkId: this.selectedParkIds,
        isActive: true
      }
      this.getBuildingListMultiple(option);
    } else {
      this.clearSelectedDataPark();
      this.selectedTenantIds = [];
      this.selectedParkAll = false;
      this.selectedBuildingAll = false;
      this.selectedTenantAll = false;
      this.selectedParkIds = [];
      // this.getBuildingListMultiple(this.selectedParkIds);
    }
  }

  groupbytenant(item) {
    return item.parkBuildingList[0].parkBuildingName;
  }

  groupbybuilding(item) {
    return item.parkList[0].parkName;
  }
}
